<template>
    <el-dialog :visible="visible" title="" :top="isMobile() ? '2vh' : '10vh'" :width="isMobile() ? '90%' : '900px'" class="announcement-dialog" :before-close="onBeforeClose">
        <div class="container">
            <div class="split-layout">
                <a style="display: flex;" href="https://www.sokuji.tw/accounting/" target="_blank">
                    <img src="@/assets/img/announcement_2024_11_01_2.jpg" alt="Sokuji 會計專區" />
                </a>
                <div class="youtube-video-wrapper">
                    <iframe
                        width="420"
                        height="236.5"
                        src="https://www.youtube.com/embed/1ZZOPYI3abo?si=ekU4P_FD87vaJwcA&amp;&rel=0&amp;modestbranding=1"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen
                    ></iframe>
                </div>
            </div>
            <div class="active-method-card" v-if="isShowSteps" ref="activeMethod">
                <div style="font-size: 18pt; font-weight: bold; margin-bottom: 20px">Sokuji 用戶訂用方式</div>
                <img class="steps-img" src="@/assets/img/announcement_2024_11_01_steps.svg" alt="Sokuji 會計專區 steps" />
                <ul class="descriptions">
                    <li>授權使用 Sokuji 會計服務專區，須由企業親自填寫所指定之 會計事務所（或財務顧問、公司會計人員）的授權資訊。</li>
                    <li>請將授權書回傳至：service@charismatw.com。</li>
                    <li>當 Sokuji 收到企業授權書後，會以 E-mail 寄送繳費單給企業授權的使用對象。</li>
                    <li>完成繳費手續後，即可登入 Sokuji 會計服務專區作業。</li>
                    <li>服務一家公司每一個使用帳號費用（年費）：公司會計 6,300 元； 財務顧問 6,300 元； 會計事務所 12,600 元。</li>
                </ul>
                <el-button class="btn" size="small" icon="el-icon-document" @click="downloadFile">下載企業授權書</el-button>
            </div>
        </div>
        <div class="dialog-footer">
            <div>
                <el-button type="highlight" class="btn" :icon="isShowSteps ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" @click="toggleShowSteps">
                    <span v-if="!isShowSteps">查看</span>
                    <span v-else>隱藏</span>
                    <span>訂用方式</span>
                </el-button>
            </div>
            <div style="display: flex; gap: 25px; align-items: center;">
                <el-checkbox v-if="isShowCheckbox" v-model="notShowAgain">不再顯示</el-checkbox>
                <el-button class="btn" @click="onBeforeClose">關閉</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>

export default {
    props: {
        visible: Boolean,
    },
    data() {
        return {
            isShowSteps: false,
            notShowAgain: false,
        };
    },
    computed: {
        isShowCheckbox() {
            return localStorage.getItem('not-display-acc-annoucement') !== '1';
        },
    },
    methods: {
        isMobile() {
            if (window.innerWidth > 500) {
                return false;
            }
            return true;
        },
        onBeforeClose() {
            if (this.notShowAgain) {
                localStorage.setItem('not-display-acc-annoucement', '1');
            }
            this.$emit('close');
        },
        toggleShowSteps() {
            this.isShowSteps = !this.isShowSteps;
            if (this.isShowSteps) {
                setTimeout(this.scrollDown, 5);
            }
        },
        scrollDown() {
            this.$refs.activeMethod.scrollIntoView({ behavior: 'smooth' });
        },
        downloadFile() {
            const url = '/files/Sokuji 系統會寄服務專區企業授權書_v2.pdf';
            const link = document.createElement('a');
            link.download = 'Sokuji 系統會寄服務專區企業授權書.pdf';
            link.href = url;
            link.click();
            link.remove();
        },
    },
};
</script>

<style lang="scss">
.announcement-dialog {
    .el-dialog {
        border: 4px solid #fff;
        overflow: hidden;
    }
    .el-dialog__header {
        display: none;
    }
    .el-dialog__body {
        padding: 0;
    }
    .container {
        display: flex;
        flex-direction: column;
        img {
            display: block;
            width: 100%;
            height: fit-content;
        }
    }
    .youtube-video-wrapper {
        iframe {
            border-radius: 20px;
            overflow: hidden;
        }
    }
    .split-layout {
        display: grid;
        grid-template-columns: auto 420px;
        align-items: center;
        padding: 50px 30px;
        gap: 30px;
        background-color: #114ce1;
        border-radius: 10px;
        margin-bottom: 4px;
    }
    .dialog-footer {
        position: relative;
        display: flex;
        background-color: #fff;
        justify-content: space-between;
        align-items: center;
        padding: 15px;
        gap: 30px;
        border-top: 1px solid #eee;
        z-index: 1;
        border-bottom-right-radius: 12px;
        border-bottom-left-radius: 12px;
    }
    .btn {
        // height: 60px;
        // border-top-right-radius: 0;
        // border-top-left-radius: 0;
    }

    .active-method-card {
        border-radius: 10px;
        padding: 50px 80px;
        overflow: hidden;
        background-color: #222;
        color: #fff;

        .layout {
            display: grid;
            grid-template-columns: 45% 55%;
            gap: 30px;
        }

        .descriptions {
            margin: 30px 0;
            font-size: 10pt;
            line-height: 160%;
        }

        .steps-img {
            width: 100%;
        }
    }
}
</style>
